// extracted by mini-css-extract-plugin
export var actionButton = "_fu-0";
export var fileInput = "_fu-2";
export var paperclip = "_fu-1";